"use strict";

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.date.now");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Statistics =
/** @class */
function () {
  function Statistics() {
    var _this = this;

    this.isGAPageViewSendedAfterScriptLoad = false;
    this.isFbInited = false;
    this.gaQueue = [];
    this.gacQueue = [];
    this.fbQueue = [];
    this.userId = '0';
    this.initialStarted = 0;
    this.readyResolver = undefined;
    this.gaId = undefined;
    this.fpId = undefined;
    this.gaConversionID = undefined;
    this.appVersion = 'Unrecognized';
    this.refParams = exports.REF_PARAMS;
    this.awaitLatency = 10000;
    this.readyPromise = new Promise(function (resolve) {
      _this.readyResolver = resolve;
    });
  }

  Statistics.prototype.injectReferrerParams = function (obj) {
    var _this = this;

    var params = {};
    this.refParams.forEach(function (refParam) {
      var param = _this.getCookie(refParam);

      if (param && param !== '[object Object]' && !EXCLUDE_FROM_INJECTION.includes(refParam)) {
        params[refParam] = param;
      }
    });
    var cid = this.cid;
    var fid = this.fid;
    var fclid = this.fclid;

    if (cid) {
      params.cid = cid;
    }

    if (fid) {
      params.fid = fid;
    }

    if (fclid) {
      params.fbc = fclid;
    }

    return __assign(__assign(__assign({}, obj), params), {
      ga_ab_group: this.gaAbGroup
    });
  };

  Statistics.prototype.patchLink = function (url) {
    var query = this.getQueryParams();
    var firstParam = false;

    if (url.indexOf('?') === -1) {
      firstParam = true;
    }

    for (var j = 0; j < this.refParams.length; j++) {
      var param = this.refParams[j];
      var valueFromCookie = this.getCookie(param);

      if (url.includes(param + "=")) {
        continue;
      }

      if (query[param]) {
        url += "" + (firstParam ? '?' : '&') + param + "=" + query[param];
        firstParam = false;
      } else if (!query[param] && valueFromCookie) {
        url += "" + (firstParam ? '?' : '&') + param + "=" + valueFromCookie;
        firstParam = false;
      }
    }

    return url;
  };

  Statistics.prototype.injectFacebookPixel = function () {
    var _this = this;

    if (!global['document']) {
      throw new Error('Method works only in browser');
    }

    if (!this.fpId) {
      throw new Error('Facebook pixel ID is not set. You can not inject facebook without it.');
    }

    this.initialStarted = Date.now();
    var query = this.getQueryParams();
    var storedFbp = query['_fbp'];

    if (storedFbp) {
      this.setCookie('_fbp', storedFbp);
    }

    var storedFbc = query['_fbc'];

    if (storedFbp) {
      this.setCookie('_fbc', storedFbc);
    }

    try {
      (function (f, b, e, v) {
        if (f.fbq) {
          return;
        }

        var n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };

        if (!f._fbq) {
          f._fbq = n;
        }

        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        var t = b.createElement(e);
        t.async = !0;
        t.src = v;
        var s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

      if (this.isFbInited) {
        this.fbQueue.forEach(function (args) {
          return _this.fbq.apply(_this.fbq, args);
        });
        this.fbQueue = [];
      }
    } catch (e) {}
  };

  Statistics.prototype.injectGaAnalytics = function () {
    var _this = this;

    if (!global['document']) {
      throw new Error('Method works only in browser');
    }

    if (!this.gaId) {
      throw new Error('Google Analitics ID is not set. You can not inject google analitics without it.');
    }

    this.initialStarted = Date.now();

    try {
      (function (i, s, o, g, r) {
        i['GoogleAnalyticsObject'] = r;
        i[r] = i[r] || function () {
          (i[r].q = i[r].q || []).push(arguments);
        }, i[r].l = Date.now();
        var a = s.createElement(o);
        var m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

      this.ga('create', this.gaId, 'auto', {
        allowLinker: true
      }); // TODO: Maybe it can be more universal

      this.ga('require', 'linker');
      this.ga('linker:autoLink', ['expertoption.com', 'app.expertoption.com', 'm.expertoption.com', 'expertoptionasia.com', 'app.expertoptionasia.com', 'm.expertoptionasia.com', 'expertoption.money', 'expertoption.finance']);
      this.ga('set', 'dimension3', this.gaAbGroup);
      this.ga('set', 'ga_ab_group', this.gaAbGroup);
      this.gaQueue.forEach(function (args) {
        return _this.ga.apply(_this.ga, args);
      });
      this.gaQueue = [];

      if (!this.isGAPageViewSendedAfterScriptLoad) {
        this.trackGa('pageview');
      }
    } catch (e) {}
  };

  Statistics.prototype.injectGaConversion = function () {
    var _this = this;

    if (!global['document']) {
      throw new Error('Method works only in browser');
    }

    if (!this.gaConversionID) {
      throw new Error('Google Conversion ID is not set. You can not inject google conversion without it.');
    }

    this.initialStarted = Date.now();
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://www.googleadservices.com/pagead/conversion_async.js';
    script.async = true;
    head.appendChild(script);
    this.gacQueue.forEach(function (args) {
      return _this.gaConversion.apply(_this.gaConversion, args);
    });
    this.gacQueue = [];
  };
  /**
   * General information
   * @see https://developers.google.com/tag-manager/quickstart
   */


  Statistics.prototype.injectGoogleTagManager = function (id, isProd) {
    if (isProd === void 0) {
      isProd = true;
    }

    this.checkRuntimeEnvironment();

    if (isProd) {
      var head = document.getElementsByTagName('head')[0];
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = "https://www.googletagmanager.com/gtm.js?id=" + id;
      script.async = true;
      head.appendChild(script);
    }

    window.dataLayer = window.dataLayer || [];

    window.gtag = function () {
      window.dataLayer.push(arguments);
    };

    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    window.gtag('js', new Date());
    window.gtag('config', id);
  };

  Statistics.prototype.setUserId = function (userId) {
    var _this = this;

    this.userId = userId;
    this.fbq('init', this.fpId, {
      external_id: userId,
      app_version: this.appVersion
    });
    this.isFbInited = true;
    this.trackFacebook('pageview');
    this.fbQueue.forEach(function (args) {
      return _this.fbq.apply(_this.fbq, args);
    });

    if (window['fbq']) {
      this.fbQueue = [];
    }

    this.ga('set', 'userId', userId);
    this.checkAllIsReady();
  };

  Statistics.prototype.paramsIsReady = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.readyPromise];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  Object.defineProperty(Statistics.prototype, "cid", {
    get: function get() {
      return this.parseCidParam('_ga');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Statistics.prototype, "fid", {
    get: function get() {
      return this.parseCidParam('_fbp');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Statistics.prototype, "fclid", {
    get: function get() {
      var cid = '';
      var fbclId = this.getCookie('_fbc');

      if (fbclId) {
        return this.parseCidParam('_fbc');
      }

      var query = this.getQueryParams();

      if (query['fbclid'] !== undefined) {
        cid = Date.now() + '.' + query['fbclid'];
        this.setCookie('_fbc', "fb.1." + cid);
      }

      return cid;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Statistics.prototype, "gaAbGroup", {
    get: function get() {
      var gaabGroup = '';
      var query = this.getQueryParams();

      if (query['_ga_ab_group'] !== undefined) {
        gaabGroup = String(query['_ga_ab_group']);
        this.setCookie('_ga_ab_group', gaabGroup);
      } else {
        gaabGroup = this.getCookie('_ga_ab_group');
      }

      if (gaabGroup) {
        return gaabGroup;
      }

      var newAbGroup = Math.round(Math.random()).toString();
      this.setCookie('_ga_ab_group', newAbGroup);
      return newAbGroup;
    },
    enumerable: true,
    configurable: true
  });

  Statistics.prototype.track = function (eventId, data) {
    if (!global['document']) {
      throw new Error('Method works only in browser');
    }

    this.trackFacebook(eventId, data);
    this.trackGa(eventId, data);
  };

  Statistics.prototype.trackPageView = function (data) {
    if (!global['document']) {
      throw new Error('Method works only in browser');
    }

    this.trackFacebook('pageview', data);
    this.trackGa('pageview', data);
  };

  Statistics.prototype.trackGoogleConversion = function (params) {
    if (!global['document']) {
      throw new Error('Method works only in browser');
    }

    this.gaConversion({
      google_conversion_id: this.gaConversionID,
      google_custom_params: params,
      google_remarketing_only: true
    });
  };

  Statistics.prototype.ga = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (arguments[0][0] === 'send' && arguments[0][0][1].hitType === 'pageview') {
      this.isGAPageViewSendedAfterScriptLoad = true;
    }

    if (window['ga']) {
      return window['ga'].apply(window['ga'], arguments);
    }

    this.gaQueue.push(arguments);
  };

  Statistics.prototype.gaConversion = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (window['google_trackConversion']) {
      return window['google_trackConversion'].apply(window['google_trackConversion'], arguments);
    }

    this.gacQueue.push(arguments);
  };

  Statistics.prototype.fbq = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (window['fbq']) {
      return window['fbq'].apply(window['fbq'], arguments);
    }

    if (arguments[0] === 'init') {
      this.fbQueue.unshift(arguments);
      return;
    }

    this.fbQueue.push(arguments);
  };

  Statistics.prototype.checkAllIsReady = function () {
    var _this = this;

    if ((this.gaId && !this.getCookie('_ga') || this.fpId && !this.getCookie('_fbp')) && this.initialStarted + this.awaitLatency > Date.now()) {
      setTimeout(function () {
        _this.checkAllIsReady();
      }, 300);
      return;
    }

    if (this.readyResolver) {
      var resolveValue = {
        readyTime: Date.now() - this.initialStarted
      };

      if (this.gaId) {
        resolveValue.gaReady = Boolean(this.getCookie('_ga'));
      }

      if (this.fpId) {
        resolveValue.facebookReady = Boolean(this.getCookie('_fbp'));
      }

      this.readyResolver(resolveValue);
    }
  };

  Statistics.prototype.trackFacebook = function (eventId, data) {
    if (eventId === 'pageview') {
      this.fbq('track', 'PageView', __assign(__assign({}, data), {
        uid: this.userId,
        fid: this.fid
      }));
      return;
    }

    var eventCategory = this.fbEvents[eventId];

    if (!eventCategory) {
      return;
    }

    if (data && data.currency && data.currency === 'CNH') {
      data.currency = 'CNY';
    }

    this.fbq('track', eventCategory, __assign(__assign({}, data), {
      uid: this.userId,
      fid: this.fid
    }));
  };

  Statistics.prototype.trackGa = function (eventId, data) {
    if (eventId === 'pageview') {
      this.ga('send', 'pageview');
      return;
    }

    var eventCategory = this.gaEvents[eventId];

    if (!eventCategory) {
      return;
    }

    var mutableEventObj = this.mutateGaEvent(eventId, eventCategory, data);

    if (mutableEventObj) {
      this.ga('send', mutableEventObj);
    }
  };

  Statistics.prototype.parseCidParam = function (paramName) {
    var cid = this.getCookie(paramName);

    if (cid) {
      var gaIdSplitted = cid.split('.');

      if (gaIdSplitted.length > 2) {
        cid = gaIdSplitted[gaIdSplitted.length - 2] + '.' + gaIdSplitted[gaIdSplitted.length - 1];
      }
    }

    return cid;
  };

  Statistics.prototype.storeRefParams = function (referrer) {
    var _this = this;

    var queryParams = this.getQueryParams();
    this.refParams.forEach(function (refParam) {
      var queryParam = queryParams[refParam];

      if (queryParam) {
        _this.setCookie(refParam, queryParam);
      }
    });

    if (queryParams['refid']) {
      this.setCookie('ctime', Math.floor(Date.now() / 1000));

      if (referrer && !this.getCookie('referer')) {
        this.setCookie('ref', encodeURIComponent(referrer));
      }
    }
  };

  Statistics.prototype.checkRuntimeEnvironment = function () {
    if (!global['document']) {
      throw new Error('Method works only in browser');
    }
  };

  return Statistics;
}();

exports.Statistics = Statistics;
exports.REF_PARAMS = ['_fbc', '_fbp', '_ga_ab_group', 'adset_id', 'banner_id', 'bonus_code', 'bonusCode', 'campaign_id', 'cid', 'click_id', 'click_url', 'ctime', 'gclid', 'id', 'keywords', 'land', 'page', 'push_asset_id', 'ref', 'referer', 'refid', 'sign_in_type', 'source_id', 'tr', 'tr2', 'uniq'];
var EXCLUDE_FROM_INJECTION = ['_fbc', '_fbp', '_ga_ab_group'];

function parseQuery() {
  var qs = location.search.split('+').join(' ');
  var params = {};
  var tokens = null;
  var re = /[?&]?([^=]+)=([^&]*)/g;

  while (tokens = re.exec(qs)) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
  }

  return params;
}

exports.parseQuery = parseQuery;